import React, { useEffect, useState } from 'react';

// Subtle gentle floating summer sparkles (replaces winter snow)
// Generates floating soft white dots that drift upward slowly - cinematic but summery
export const SummerSparkles = ({ count = 35, color = 'white' }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const p = Array.from({ length: count }).map(() => ({
      left: Math.random() * 100,
      size: 2 + Math.random() * 4,
      duration: 12 + Math.random() * 18,
      delay: Math.random() * 10,
      opacity: 0.25 + Math.random() * 0.45,
    }));
    setParticles(p);
  }, [count]);

  return (
    <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
      {particles.map((p, i) => (
        <span
          key={i}
          className="absolute bottom-[-20px] rounded-full animate-float-up"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: color,
            opacity: p.opacity,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            boxShadow: `0 0 ${p.size * 2}px ${color}`,
          }}
        />
      ))}
    </div>
  );
};
